import { dimensionSelector } from '@common/redux/selectors/page';
import { useLocation } from '@common/routes/hooks';
import { ElementType, IPage } from '@common/types';
import { getPaddingBottomScreen } from '@common/utils/screen';
import { isEmpty, isNil } from 'lodash';
import { default as queryString, ParsedQuery } from 'query-string';
import React, { useLayoutEffect, useMemo, useRef } from 'react';
import { KeyboardAvoidingView, Platform, ScrollView } from 'react-native';
import { useSelector } from 'react-redux';
import qs from 'query-string';
import ObjectRender from '../ObjectRender';

type Props = {
  arrNormal: ElementType[];
  screen: IPage;
};

function NormalComponent({ arrNormal, screen }: Props) {
  const ref: any = useRef();

  const { search } = useLocation();

  const pathname = qs.parse(search);

  const dimension = useSelector(dimensionSelector);

  const isPullToRefresh = useMemo(
    () => screen?.attributes?.pullToRefresh || false,
    [screen]
  );

  const originY = dimension.height / screen.height;

  const paddingBottom = getPaddingBottomScreen(screen, originY);

  const { hiddenStatusBar }: ParsedQuery<any> = useMemo(
    () => queryString.parse(search),
    [search]
  );

  const isShowStatusBar =
    !screen.isModal &&
    !(Platform.OS === 'android' || Platform.OS === 'ios') &&
    !hiddenStatusBar &&
    screen?.attributes?.statusBarStyle !== 'hidden';

  useLayoutEffect(() => {
    const { targetModal } = pathname;
    if (isNil(targetModal) || isEmpty(targetModal)) {
      ref?.current?.scrollTo({ y: 0, x: 0 });
    }
  }, [screen, ref, pathname]);

  return (
    <KeyboardAvoidingView
      behavior={Platform.OS === 'android' ? undefined : 'padding'}
      style={{ flex: 1 }}
      // keyboardVerticalOffset={50}
    >
      <ScrollView
        bounces={isPullToRefresh}
        contentInsetAdjustmentBehavior="automatic"
        showsVerticalScrollIndicator={false}
        showsHorizontalScrollIndicator={false}
        keyboardShouldPersistTaps="handled"
        ref={ref}
        // style={{ flex: 1, paddingBottom: paddingBottom }}
        contentContainerStyle={{
          flexGrow: 1,
          paddingBottom: paddingBottom,
        }}
        {...(Platform.OS === 'android' && { overScrollMode: 'never' })}
      >
        {arrNormal.length > 0 && (
          <ObjectRender
            arrComp={arrNormal}
            isScreen={true}
            isShowStatusBar={isShowStatusBar}
            screen={screen}
          />
        )}
      </ScrollView>
    </KeyboardAvoidingView>
  );
}

export default NormalComponent;
